import {
  clearWindowNameSession,
  readStorageValue,
  readWindowNameSession,
  removeStorageValue,
} from '../utils/storage';

export const consumeLegacyAccessToken = () => {
  const legacyToken = readLegacyAccessToken();
  removeStorageValue('token');
  clearWindowNameSession();
  return legacyToken;
};

export const readLegacyAccessToken = () => {
  const windowSession = readWindowNameSession();
  return readStorageValue('token') || windowSession?.token || '';
};

export const clearPersistedAccessToken = () => {
  removeStorageValue('token');
  clearWindowNameSession();
};

export const isModernAccessToken = (token) => {
  if (typeof token !== 'string') return false;
  const parts = token.split('.');
  if (parts.length !== 3) return false;
  try {
    const normalized = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(
      normalized.length + ((4 - (normalized.length % 4)) % 4),
      '='
    );
    const payload = JSON.parse(globalThis.atob(padded));
    return payload?.authVersion === 2 && payload?.tokenType === 'access';
  } catch {
    return false;
  }
};

export const requestRefreshWithRetry = async (
  api,
  { legacyToken = '', retryDelayMs = 150, maxConflictRetries = 2 } = {}
) => {
  let conflictRetries = 0;

  while (true) {
    try {
      const headers = {
        'X-BPM-Refresh': '1',
        ...(legacyToken
          ? { Authorization: `Bearer ${legacyToken}` }
          : {}),
      };
      return await api.post('/auth/refresh', null, {
        headers,
        skipAuthHeader: true,
        skipAuthRefresh: true,
        withCredentials: true,
      });
    } catch (error) {
      const isRefreshConflict =
        error?.response?.status === 409 &&
        error?.response?.data?.code === 'REFRESH_RETRY';
      if (!isRefreshConflict || conflictRetries >= maxConflictRetries) {
        throw error;
      }
      conflictRetries += 1;
      await new Promise((resolve) => setTimeout(resolve, retryDelayMs));
      legacyToken = '';
    }
  }
};
